interface offsetProps {
    top: number;
    left: number;
}

interface optionsProps {
    root: null | HTMLElement;
    rootMargin: string;
    threshold: number;
}

export default class Animation {
    static init(): void {
        this.handleObserveAnim();

        setTimeout(() => {
            this.handleCountUpNumber();
        }, 250);
    }

    static offset(el: HTMLElement): offsetProps {
        const rect = el.getBoundingClientRect(),
            scrollLeft = window.scrollX || document.documentElement.scrollLeft,
            scrollTop = window.scrollY || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }

    static handleObserveAnim(): void {
        const els: NodeListOf<HTMLElement> = document.querySelectorAll('.js-animation');

        const options: optionsProps = {
            root: null, // The document viewport (default)
            rootMargin: '0px', // No offset from the root element (default)
            threshold: 0.3, // Call on 30% visibility
        };

        if (els.length > 0) {
            els.forEach((el: HTMLElement) => {
                Animation.setObserver(options, el);
            });
        }
    }

    static setObserver(options: optionsProps, element: HTMLElement): void {
        const observer = new IntersectionObserver((entries, observer) => {
            if (entries[0].intersectionRatio <= options.threshold) {
                return;
            }
            observer.disconnect();

            const target = entries[0].target;
            target.classList.add('js-animation-entered');
        }, options);

        observer.observe(element);
    }

    static handleCountUpNumber(): void {
        const objects: NodeListOf<HTMLElement> = document.querySelectorAll('.count-up-number-animation');
        if (objects.length > 0) {
            objects.forEach((obj: HTMLElement) => {
                const start = 0;
                const endString = obj.dataset.value;
                const durationString = obj.dataset.duration;
                const delay = parseFloat(obj.dataset.delay || "0");
                const fractionDigits = endString?.match(/(?:\.)(\d+)/)?.[1]?.length || 0;
                const formatter = new Intl.NumberFormat(undefined, {
                    maximumFractionDigits: fractionDigits,
                    useGrouping: obj.dataset.grouping !== "false"
                });
                if (
                    endString &&
                    durationString &&
                    !obj.classList.contains('count-up-number-animation--animated') &&
                    obj.closest('.js-animation-entered')
                ) {
                    const frameDuration = 1000 / 60;
                    const animationDuration: number = +durationString;
                    const totalFrames = Math.round(animationDuration / frameDuration);
                    const easeOutQuad = (t: number) => t * (2 - t);

                    const animateCountUp = (el: HTMLElement) => {
                        let frame = 0;
                        const countTo = parseFloat(endString);
                        const counter = setInterval(() => {
                            frame++;
                            const progress = easeOutQuad(frame / totalFrames);
                            const currentCount = countTo * progress;

                            if (parseInt(el.innerHTML, 10) !== currentCount) {
                                el.innerHTML = formatter.format(currentCount);
                            }

                            if (frame === totalFrames) {
                                clearInterval(counter);
                            }
                        }, frameDuration);
                        obj.classList.add('count-up-number-animation--animated');
                    };
                    setTimeout(() => animateCountUp(obj), delay);
                }
            });
        }
    }
}
